import * as Mod1 from "./connectors/topic-link/d-tooltips.gjs";
const compatModules = {
  "connectors/topic-link/d-tooltips": Mod1,
};
export default compatModules;
